<template>
    <div id="login">
      <el-dialog title="手机号登录" :visible="loginDialog" width="20%" :before-close="loginClose">
        <div class="dialogFrom">
          <el-input placeholder="请输入您的手机号" prefix-icon="el-icon-mobile" v-model="account"></el-input>
          <el-input placeholder="请输入您的密码" prefix-icon="el-icon-unlock" v-model="password"></el-input>
          <!-- <p><el-checkbox v-model="checked">自动登录</el-checkbox> <span class="dialogText">忘记密码</span> </p> -->
          <el-button type="warning" @click="getLogin">登录</el-button>
          <p>还没账户？<span class="dialogText" @click="goRegister">马上注册</span> </p>
        </div>
        <span slot="footer" class="dialog-footer"></span>
      </el-dialog>
      <Register ref="register"></Register>
    </div>
  </template>
  <script>
  import Register from '../components/register'
  export default {
    components: {
        Register
    },
    data() {
      return {
        loginDialog: false,
        checked:false,
        account:'',
        password:''
      }
    },
    mounted() {
    },
    methods: {
      getLogin(){
        this.$fetch('getLogin',{account:this.account,password:this.password}).then(res => {
          if(res.code == 200){
            this.loginDialog = false;
            this.$message({
              message: '登录成功',
              type: 'success'
            });
            this.$cookie.set('account',this.account);
            location.reload()
          }else{
            this.$message({
              message: '登录失败，请稍后重试！',
              type: 'warning'
            });
          }
        })
      },
      toLogin(){
        this.loginDialog = true;
      },
      loginClose(done) {
        this.loginDialog = false
      },
      goRegister(){
        this.loginDialog = false
        this.$refs.register.toRegister();
      }
    }
  }
  </script>


// WEBPACK FOOTER //
// src/components/login.vue